import CommonLandingContainer from 'src/components/landingComponents/containers/common';
import styles from './result.module.scss';
import {
  Heading1,
  Heading2,
  Title,
  SubTitle,
  Body,
  SmallText,
  SecondaryText,
  Info,
  Button,
  Heading3,
} from 'src/components/landingComponents/typography';
import AnimatedBox from 'src/components/landingComponents/containers/animatedScroll';
import { getClassName } from 'src/Core/utility/jsx';

const Result = () => {
  return (
    <CommonLandingContainer className={styles.container}>
      <Instruction />
      <Phone />
    </CommonLandingContainer>
  );
};

export default Result;

const Phone = () => {
  return (
    <AnimatedBox className={getClassName([styles.phoneContainer])}>
      {/* <PhoneScreen className={styles.phone} alt="экран телефона" /> */}
    </AnimatedBox>
  );
};

const Instruction = () => {
  return (
    <AnimatedBox className={getClassName([styles.instructions])}>
      <Title className={styles.resultTitle} accent>Что можно сделать с результатом?</Title>
      <InfoBlock
        accentText="Скопировать уникальный код,"
        text=" который находится в верхней части страницы, чтобы сохранить результат и вернуться к нему позже"
      ></InfoBlock>
      <InfoBlock
        accentText="Использовать этот код в поле «Данные существующего запроса»,"
        text=" чтобы добавить или изменить информацию"
      ></InfoBlock>
      <InfoBlock
        accentText="Поделиться кодом с другим человеком,"
        text=" если хотите, чтобы он увидел ваш результат. Код заменяет логин и пароль — он уникален, и случайно угадать его невозможно"
      ></InfoBlock>
    </AnimatedBox>
  );
};

const InfoBlock = ({ accentText, text }) => {
  return (
    <SecondaryText>
      <span className={styles.instrAccentText}>{accentText}</span>
      {text}
    </SecondaryText>
  );
};
